import "../css/lines.css";
import CuDropdown from "../../common_component/component/CuDropdown";
import { TYPE, medicineStockAtom } from "../constants/_constant";
import CuInput from "../../all-patient/components/CuInput";
import { MdAdd } from "react-icons/md";
import { IoClose } from "react-icons/io5";
import { Popup } from "semantic-ui-react";
import {
  useItemsFilter,
  useItemsFilterNew,
} from "../../_helper/actions/app/items";
import { useEffect, useState } from "react";
import CuSuggestionBox from "../../common_component/component/CuSuggestionBox";
import {
  // calculateDiscountedPrice,
  validateDiscAmt,
} from "../helpers/_invoiceHelpers";
import { useAtom } from "jotai";
import { clinicAtom } from "../../_helper/constant/constant-atom";
import { ApiEndPoint } from "../../_helper/constant/api-types";
import { toast } from "react-toastify";
import SubLine from "./SubLine";

const Lines = ({
  line,
  idx,
  calculateAllTotal,
  lineLevelDisc,
  invoiceData,
  setInvoiceData,
  isView,
  throwAppointment,
}) => {
  const [searchInput, setSearchInput] = useState({
    subLine: "",
    mainLine: "",
    uom: "",
  });
  const [clinic] = useAtom(clinicAtom);
  // const [selectedMedicine, setSelectedMedicine] = useState(null);
  // const [medicineStocks, setMedicineStock] = useAtom(medicineStockAtom);
  // const [toastId, setToastId] = useState(null);

  const modifyLineSuggestion = (response) => {
    const modifiedData =
      response?.data?.map((data) => {
        if (data?.name_of_package) {
          return {
            ...data,
            description: data?.name_of_package,
            type: "package",
          };
        } else {
          return {
            ...data,
            description: data?.name_of_service,
            type: "service",
          };
        }
      }) || [];
    return modifiedData;
  };

  const handleSelectService = (val, idx) => {
    if (val) {
      setInvoiceData((prev) => {
        const temp = [...prev?.invoice_lines];
        const data = {
          discount: 0,
          discount_type: "percentage",
          price: val?.price,
          type: temp[idx]?.type,
          quantity: 1,
          sub_lines: temp[idx]?.sub_lines,
          description: val?.description,
          uom: "",
          total: val?.price,
          line_service: val?.type === "service" ? val : null,
          line_package: val?.type === "package" ? val : null,
        };
        temp[idx] = data;
        const calculatedLines = calculateAllTotal(temp);
        return { ...prev, ...calculatedLines };
      });
      // setIsCalculated(true);
    }
    clearInput();
  };

  // const handleConsultingCharges = (response) => {
  //   return response.data;
  //   // if (response?.data?.length > 0) {
  //   //   handleSelectService(response?.data[0], 0);
  //   // }
  // };

  const queryForConsultingCharges = `?action=getClinicServices&frontend=True&clinic_id=${clinic?.id}&name_of_service=Consulting charges`;
  const { data: consultingCharges } = useItemsFilterNew(
    ApiEndPoint.SERVICE_PKG_SEARCH,
    queryForConsultingCharges,
    clinic?.id && throwAppointment && !invoiceData?.id ? true : false,
    modifyLineSuggestion
  );

  useEffect(() => {
    if (consultingCharges?.length > 0) {
      handleSelectService(consultingCharges[0], 0);
    }
  }, [consultingCharges]);

  const queryForPackages = `?action=getSearchServicesPackages&frontend=True&clinic_id=${clinic?.id}&search_clinic=${clinic?.id}&search=${searchInput?.mainLine}`;
  const { data: packagesData, isLoading: packageLoading } = useItemsFilterNew(
    ApiEndPoint.SERVICE_PKG_SEARCH,
    queryForPackages,
    clinic?.id && searchInput?.mainLine?.length > 0 ? true : false,
    modifyLineSuggestion
  );

  // const { data: medicines } = useItemsFilter(
  //   `master_data/name_medicine/`,
  //   `?medicine_name=${searchInput?.subLine}`,
  //   searchInput?.subLine?.length > 0 ? true : false
  // );

  const { data: unitData, isLoading: unitLoading } = useItemsFilterNew(
    ApiEndPoint.CLINIC,
    `?action=getUnitsOfMeasure&clinic_id=${clinic?.id}&backend=True&name=${searchInput?.uom}`,
    clinic?.id && searchInput?.uom?.length > 0 ? true : false,
    (res) => res?.data
  );

  const handleSelectSubLine = (val, subLineIdx, mainLineIdx) => {
    setInvoiceData((prev) => {
      const temp = [...prev?.invoice_lines];
      const subLines = temp[mainLineIdx]?.sub_lines || [];
      subLines[subLineIdx] = {
        ...subLines[subLineIdx],
        price: val?.price || 0,
        medicine_name: val?.medicine_name || "",
        medicine_id: val?.id || "",
        generic_name: val?.generic_name || "",
        uom: val?.uom || "",
        medicine_stock: val?.medicine_stock,
      };
      temp[mainLineIdx].sub_lines = subLines;
      const calculatedLines = calculateAllTotal(temp);
      return { ...prev, ...calculatedLines };
    });
  };

  // const { data: medicineStock, isLoading: medicineStockLoading } =
  //   useItemsFilter(
  //     'inventory/',
  //     `?action=getMedicineStock&backend=true&clinic_id=${clinic?.id}&master_data_id=${selectedMedicine?.data?.id}`,
  //     clinic?.id && selectedMedicine?.data?.id ? true : false,
  //     '',
  //     0,
  //   );

  // useEffect(() => {
  //   if (medicineStockLoading) {
  //     const id = toast.loading(
  //       'Wait we are checking the stock of selected medicine',
  //     );
  //     setToastId(id);
  //   } else {
  //     toast.update(toastId, {
  //       render: 'Stock loaded successfully!',
  //       type: 'success',
  //       isLoading: false,
  //       autoClose: 3000,
  //     });
  //   }
  // }, [medicineStockLoading]);

  // useEffect(() => {
  //   if (medicineStock && selectedMedicine) {
  //     let extracted = {
  //       id: selectedMedicine?.data?.id || null,
  //       medicine_name: selectedMedicine?.data?.medicine_name || '',
  //       generic_name: selectedMedicine?.data?.generic_name?.name || '',
  //       price: medicineStock?.length > 0 ? medicineStock[0]?.price : 0,
  //       uom: medicineStock?.length > 0 ? medicineStock[0]?.uom : '',
  //       // expiry_date:
  //       //   medicineStock?.length > 0 ? medicineStock[0]?.expiry_date : "",
  //     };

  //     if (medicineStock?.length === 0) {
  //       extracted = {
  //         id: null,
  //         medicine_name: '',
  //         generic_name: '',
  //         price: 0,
  //         uom: '',
  //       };
  //       toast.error('This medicine is out of stock');
  //     }

  //     handleSelectSubLine(
  //       extracted,
  //       selectedMedicine?.subLineIdx,
  //       selectedMedicine?.mainLineIdx,
  //     );
  //     setSelectedMedicine(null);
  //     setMedicineStock(medicineStock);
  //   }
  // }, [medicineStock, selectedMedicine]);

  const handleLineChange = (val, label, idx) => {
    if (label === "price") {
      setInvoiceData((prev) => {
        const temp = [...prev?.invoice_lines];
        temp[idx][label] = val;
        const calculatedLines = calculateAllTotal(temp);
        return { ...prev, ...calculatedLines };
      });
      return;
      // setIsCalculated(true);
    }

    if (label === "discount") {
      if (Number(val) < 0) {
        return;
      }

      const type = invoiceData?.invoice_lines[idx]?.discount_type;
      const isValidate = validateDiscAmt(
        Number(invoiceData?.invoice_lines[idx]?.price) *
          Number(invoiceData?.invoice_lines[idx]?.quantity),
        val,
        type
      );

      if (isValidate) {
        setInvoiceData((prev) => {
          const temp = [...prev?.invoice_lines];
          temp[idx].discount = Number(val);
          const calculatedLines = calculateAllTotal(temp);
          return { ...prev, ...calculatedLines };
        });
        // setIsCalculated(true);
      }
      return;
    }
    if (label === "quantity") {
      if (Number(val) < 0) {
        // val = "";
        return;
      }
      setInvoiceData((prev) => {
        const temp = [...prev?.invoice_lines];
        temp[idx].quantity = val;
        const calculatedLines = calculateAllTotal(temp);
        return { ...prev, ...calculatedLines };
      });
      // setIsCalculated(true);
      return;
    }
    if (label === "description" && val?.length === 0) {
      const blankLine = {
        discount: "0",
        discount_type: "percentage",
        price: "0",
        type: "Amt",
        description: "",
        quantity: 1,
        sub_lines: [],
        uom: "",
        total: 0,
        line_service: null,
        line_package: null,
      };
      setInvoiceData((prev) => {
        const temp = [...prev?.invoice_lines];
        temp[idx] = blankLine;
        return { ...prev, invoice_lines: temp };
      });
      return;
    }
    setInvoiceData((prev) => {
      const temp = [...prev?.invoice_lines];
      temp[idx][label] = val;
      return { ...prev, invoice_lines: temp };
    });
  };

  const createBlankLine = () => {
    setInvoiceData((prev) => {
      return {
        ...prev,
        invoice_lines: [
          ...prev?.invoice_lines,
          {
            discount: "0",
            discount_type: "percentage",
            price: "0",
            type: "Amt",
            quantity: 1,
            description: "",
            sub_lines: [],
            uom: "",
            total: 0,
            line_service: null,
            line_package: null,
          },
        ],
      };
    });
  };

  const createBlankSubLine = (mainLineIdx) => {
    if (!invoiceData?.invoice_lines[mainLineIdx]?.line_service?.id) {
      toast.error("Please select any service");
      return;
    }
    if (
      !invoiceData?.invoice_lines[mainLineIdx]?.line_service?.service_type
        ?.offset
    ) {
      toast.error("The service type of this service does not exist");
      return;
    }

    setInvoiceData((prev) => {
      const temp = [...prev?.invoice_lines];
      const subLineObj = {
        id: temp[mainLineIdx]?.sub_lines?.length + 1,
        discount: "0",
        discount_type: "percentage",
        price: "0",
        // expiry: "",
        medicine_name: "",
        medicine_id: null,
        generic_name: "",
        batch_no: [],
        quantity: "0",
        uom: "",
        total: 0,
        // data: null,
      };
      const subLines = [...temp[mainLineIdx]?.sub_lines, subLineObj];
      temp[mainLineIdx].sub_lines = subLines;
      return { ...prev, invoice_lines: temp };
    });
  };

  const deleteLine = (idx) => {
    if (invoiceData?.invoice_lines?.length > 1) {
      setInvoiceData((prev) => {
        const temp = [...prev?.invoice_lines];
        temp?.splice(idx, 1);
        const calculatedLines = calculateAllTotal(temp);
        return { ...prev, ...calculatedLines };
      });
    } else {
      setInvoiceData((prev) => {
        const blankLine = [
          {
            discount: "0",
            discount_type: "percentage",
            price: "0",
            type: "Amt",
            description: "",
            quantity: 1,
            sub_lines: [],
            uom: "",
            total: 0,
            line_service: null,
            line_package: null,
          },
        ];
        const calculatedLines = calculateAllTotal(blankLine);
        return {
          ...prev,
          ...calculatedLines,
        };
      });
    }
    // setIsCalculated(true);
  };

  const deleteSubLine = (mainLineIdx, id) => {
    setInvoiceData((prev) => {
      const temp = [...prev?.invoice_lines];
      const subLines =
        temp[mainLineIdx]?.sub_lines?.filter((sub) => sub?.id !== id) || [];
      temp[mainLineIdx].sub_lines = subLines;
      const calculatedLines = calculateAllTotal(temp);
      return { ...prev, ...calculatedLines };
    });
    // setIsCalculated(true);
  };

  const handleSearch = (value, label) => {
    setSearchInput({ subLine: "", mainLine: "", uom: "", [label]: value });
  };

  const clearInput = () => {
    setSearchInput({ subLine: "", mainLine: "", uom: "" });
  };

  // const getTotalBatchCount = (mainLineIdx, subLineIdx) => {
  //   const { invoice_lines } = invoiceData || [];
  //   const { sub_lines } = invoice_lines[mainLineIdx] || [];
  //   const { batch_no } = sub_lines[subLineIdx] || [];
  //   const totalBatchQty = batch_no?.reduce(
  //     (sum, batch) => sum + batch.batchQty,
  //     0
  //   );
  //   return totalBatchQty;
  // };

  const handleSubLineChange = (val, label, subLineIdx, mainLineIdx) => {
    if (label === "price") {
      setInvoiceData((prev) => {
        const temp = [...prev?.invoice_lines];
        const subLines = temp[mainLineIdx]?.sub_lines || [];
        subLines[subLineIdx] = { ...subLines[subLineIdx], [label]: val };
        temp[mainLineIdx].sub_lines = subLines;
        const calculatedLines = calculateAllTotal(temp);
        return { ...prev, ...calculatedLines };
      });
      return;
      // setIsCalculated(true);
    }
    if (label === "quantity") {
      // const totalBatchQty = getTotalBatchCount(mainLineIdx, subLineIdx);

      // if (Number(val) > Number(totalBatchQty)) {
      //   toast.error(
      //     "Batch quantity is insufficient. Please select additional batches to match the invoice quantity."
      //   );
      //   return;
      // }

      if (Number(val) < 0) {
        return;
      }

      setInvoiceData((prev) => {
        const temp = [...prev?.invoice_lines];
        const subLines = temp[mainLineIdx]?.sub_lines || [];
        subLines[subLineIdx] = {
          ...subLines[subLineIdx],
          quantity: val,
        };
        temp[mainLineIdx].sub_lines = subLines;
        const calculatedLines = calculateAllTotal(temp);
        return { ...prev, ...calculatedLines };
      });
      // setIsCalculated(true);
      return;
    }
    if (label === "discount") {
      if (Number(val) < 0) {
        return;
      }
      const type =
        invoiceData?.invoice_lines[mainLineIdx]?.sub_lines[subLineIdx]
          ?.discount_type;
      const total =
        Number(
          invoiceData?.invoice_lines[mainLineIdx]?.sub_lines[subLineIdx]?.price
        ) *
        Number(
          invoiceData?.invoice_lines[mainLineIdx]?.sub_lines[subLineIdx]
            ?.quantity
        );
      const isValidate = validateDiscAmt(total, val, type);
      if (isValidate) {
        setInvoiceData((prev) => {
          const temp = [...prev?.invoice_lines];
          const subLines = temp[mainLineIdx]?.sub_lines || [];
          subLines[subLineIdx] = { ...subLines[subLineIdx], [label]: val };
          temp[mainLineIdx].sub_lines = subLines;
          const calculatedLines = calculateAllTotal(temp);
          return { ...prev, ...calculatedLines };
        });
        // setIsCalculated(true);
      }
      return;
    }
    setInvoiceData((prev) => {
      const temp = [...prev?.invoice_lines];
      const subLines = temp[mainLineIdx]?.sub_lines || [];
      subLines[subLineIdx] = { ...subLines[subLineIdx], [label]: val };
      temp[mainLineIdx].sub_lines = subLines;
      return { ...prev, invoice_lines: temp };
    });
  };

  // const handleSelectMedicine = (val, subLineIdx, mainLineIdx) => {
  //   setSelectedMedicine({ data: val, subLineIdx, mainLineIdx });
  //   // handleSelectSubLine(val, subLineIdx, mainLineIdx);
  //   clearInput();
  // };

  const handleSelectUOM = (val, idx) => {
    if (val) {
      setInvoiceData((prev) => {
        const temp = [...prev?.invoice_lines];
        temp[idx] = { ...temp[idx], uom: val?.name };
        return { ...prev, invoice_lines: temp };
      });
    }
    clearInput();
  };

  const handleSelectSubLineUom = (val, subLineIdx, mainLineIdx) => {
    setInvoiceData((prev) => {
      const temp = { ...prev };
      const subLines = temp?.invoice_lines[mainLineIdx]?.sub_lines || [];
      subLines[subLineIdx] = {
        ...subLines[subLineIdx],
        uom: val?.name,
      };
      temp.invoice_lines[mainLineIdx].sub_lines = subLines;
      return temp;
    });
    clearInput();
  };

  const handleSelectBatch = (e, batch, mainLineIdx, subLineIdx) => {
    const flag = e.target.checked;

    // const selectedBatch = medicineStocks?.find(
    //   (ele) =>
    //     ele?.batch_number?.toLowerCase() === batch?.batch_number?.toLowerCase()
    // );

    if (flag) {
      setInvoiceData((prev) => {
        const temp = [...prev?.invoice_lines];
        const subLines = temp[mainLineIdx]?.sub_lines || [];
        const batch_no = subLines[subLineIdx]?.batch_no || [];
        // batch_no.push(batch?.id);
        batch_no.push({
          batchId: batch?.batch_id,
          batchQty: batch?.avl_batch_qty,
          batchNo: batch?.batch_number,
          expiry: batch?.expiry_date,
          // inward_qty: selectedBatch?.inward_qty,
          // received_date: selectedBatch?.received_date,
          // consumed_qty: selectedBatch?.consumed_qty,
        });
        subLines[subLineIdx].batch_no = batch_no;
        temp[mainLineIdx].sub_lines = subLines;
        return { ...prev, invoice_lines: temp };
      });
    } else {
      setInvoiceData((prev) => {
        const temp = [...prev?.invoice_lines];
        const subLines = temp[mainLineIdx]?.sub_lines || [];
        const batch_no = subLines[subLineIdx]?.batch_no || [];
        const filteredBatch =
          batch_no?.filter((bt) => bt?.batchId !== batch?.batch_id) || [];
        subLines[subLineIdx] = {
          ...subLines[subLineIdx],
          batch_no: filteredBatch,
        };
        temp[mainLineIdx].sub_lines = subLines;
        return { ...prev, invoice_lines: temp };
      });
    }
  };

  const getPriceDisabled = () => {
    if (isView) {
      return true;
    }

    if (line?.line_service?.id || line?.line_package?.id) {
      return false;
    }

    return true;
  };

  return (
    <>
      <div className="cu-invoice-line-cont">
        <div>
          <label>Type</label>
          <CuDropdown
            options={TYPE}
            style={{ height: "36px" }}
            value={line?.type}
            onChange={(val) => handleLineChange(val, "type", idx)}
            id={"lines"}
            disabled={isView}
          />
        </div>
        <div>
          <CuSuggestionBox
            options={packagesData}
            label={"Description"}
            renderKey={"description"}
            searchInput={searchInput?.mainLine}
            searchable
            setSearchInput={(val) => handleSearch(val, "mainLine")}
            onChange={(val) => handleLineChange(val, "description", idx)}
            handleSelectOption={(val) => handleSelectService(val, idx)}
            value={
              line?.description ||
              line?.line_service?.name_of_service ||
              line?.line_package?.name_of_package
            }
            disabled={isView}
            loading={packageLoading}
            position="calc(50% + 4px)"
          />
        </div>
        {line?.type === "Qty" && (
          <div>
            <label>Quantity</label>
            <CuInput
              type={"number"}
              placeholder={"select"}
              value={line?.quantity}
              onChange={(e) =>
                handleLineChange(e.target.value, "quantity", idx)
              }
              disabled={isView}
            />
          </div>
        )}
        {line?.type === "Qty" && (
          <div>
            <CuSuggestionBox
              options={unitData}
              label={"UOM"}
              renderKey={"name"}
              searchInput={searchInput?.uom}
              searchable
              setSearchInput={(val) => handleSearch(val, "uom")}
              onChange={(val) => handleLineChange(val, "uom", idx)}
              handleSelectOption={(val) => handleSelectUOM(val, idx)}
              value={line?.uom}
              disabled={isView}
              loading={unitLoading}
              position="calc(50% + 4px)"
            />
          </div>
        )}
        <div>
          <label>Price</label>
          <CuInput
            type={"number"}
            placeholder={"select"}
            value={line?.price}
            disabled={getPriceDisabled()}
            onChange={(e) => handleLineChange(e.target.value, "price", idx)}
          />
        </div>
        <div>
          <div className="cu-invoice-line-discount-label">
            <label>Discount</label>
            <input
              type="checkbox"
              disabled={!lineLevelDisc}
              checked={line?.discount_type === "amount" ? false : true}
              onChange={() => {}}
              onClick={(e) =>
                handleLineChange(
                  line?.discount_type === "amount" ? "percentage" : "amount",
                  "discount_type",
                  idx
                )
              }
            />
          </div>
          <CuInput
            type={"number"}
            placeholder={"select"}
            disabled={!lineLevelDisc}
            value={line?.discount}
            onChange={(e) => handleLineChange(e.target.value, "discount", idx)}
          />
        </div>
        <div className="cu-invoice-line-INR-field">
          <label>INR</label>
          <div className="cu-invoice-line-INR">
            {line?.total ? line?.total : line?.price}
          </div>
        </div>
        <div className="cu-invoice-line-icons">
          <IoClose
            size={20}
            className="cursor-pointer"
            onClick={() => deleteLine(idx)}
          />
          <Popup
            trigger={<MdAdd size={20} className="cursor-pointer" color="red" />}
            hoverable
            content={
              <div className="flex flex-col">
                <span
                  className="cursor-pointer hover:bg-gray-200 p-1"
                  onClick={() => createBlankSubLine(idx)}
                >
                  Add Sub Line
                </span>
                <span
                  className="cursor-pointer hover:bg-gray-200 p-1"
                  onClick={() => createBlankLine()}
                >
                  Add Main Line
                </span>
              </div>
            }
          />
        </div>
      </div>
      {line?.sub_lines?.map((subLine, subIdx) => (
        <SubLine
          key={subIdx}
          subLine={subLine}
          subIdx={subIdx}
          handleSubLineChange={handleSubLineChange}
          idx={idx}
          // handleSelectMedicine={handleSelectMedicine}
          handleSelectSubLine={handleSelectSubLine}
          isView={isView}
          handleSelectSubLineUom={handleSelectSubLineUom}
          lineLevelDisc={lineLevelDisc}
          deleteSubLine={deleteSubLine}
          handleSelectBatch={handleSelectBatch}
        />
      ))}
    </>
  );
};

export default Lines;
